import './flexnav';
import 'cookieconsent';
import './heroCheck';
import './jumpToMarketContacts';
import './navigationbar'

export default {
    init: () => {
        // custom add active
        //$('a').filter(function () {
        //    return this.href === location.href;
        //}).addClass('active');

        // When a user presses space on a link button while navigating with the keyboard, instead of scrolling (default web browser behavior), click the link
        window.addEventListener('keydown', function (e) {
            let activeElement = document.activeElement;
            if (activeElement.nodeName === "A" && activeElement.getAttribute('role')?.toLowerCase() === "button" && e.key === " ") {
                e.preventDefault();
                activeElement.click();
            }
        });

        var lastKnownWrapperMargin = 0;
        function adjustHeaderForScroll() {
            const posOffset = $('.dismissable-banner').height();
            const scrolled = $(document).scrollTop() > posOffset;
            $('#header').toggleClass('sticky scrolled', scrolled);
            if (!scrolled) updateTopOfPage();
            $('div#wrapper').css({ 'margin-top': (scrolled ? unscrolledHeaderHeight : 0) + "px" });
            lastKnownWrapperMargin = (scrolled ? unscrolledHeaderHeight : 0);
        }

        var unscrolledHeaderHeight = $("#header .header-main").outerHeight() + $("#header .header-bottom").outerHeight();
        function updateTopOfPage() {
            unscrolledHeaderHeight = $("#header .header-main").outerHeight() + $("#header .header-bottom").outerHeight();
            $(".page__top, .page-with-hero").css({ 'margin-top': -unscrolledHeaderHeight + "px" });
        };

        window.onbeforeprint = () => $('div#wrapper').css({ 'margin-top': 0 });
        window.onafterprint = () => $('div#wrapper').css({ 'margin-top': lastKnownWrapperMargin + "px" });

        window.addEventListener('resize', function () {
            if ($(document).scrollTop() <= 0)
                updateTopOfPage();
        }, true);

        // On page load
        if ($(window).scrollTop() > 0) {
            adjustHeaderForScroll();
        }

        function adjustScrollTopVisibility() {
            // Show/hide ScrollToTop button
            if ($(window).scrollTop() > 50) {
                $('#scroll_top').fadeIn();
            } else {
                $('#scroll_top').fadeOut();
            }
        }
        adjustScrollTopVisibility(); // On page load

        $(window).scroll(function () {
            adjustHeaderForScroll();
            adjustScrollTopVisibility();
        });

        // offset sticky nav on product pages
        $('a.scroll-to-link').on('click', e => {
            e.preventDefault();
            const $stickyHeader = $('.product-sticky-header');
            const $nav = $('.sticky-bar-wrapper');
            const offsetNav = $nav.length ? $nav.height() : 0;
            const stickyHeaderHeight = $stickyHeader.length ? $stickyHeader.outerHeight() : 0;

            const anchor = $(e.currentTarget).attr('href');

            const $el = $(anchor);
            if ($el.length) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $el.offset().top - offsetNav - stickyHeaderHeight
                }, 500);
            }
        });

        $(function () {
            $('.dropdown').on({
                "click": function (event) {
                    if ($(event.target).closest('.dropdown-toggle').length) {
                        $(this).data('closable', true);
                    } else {
                        $(this).data('closable', false);
                    }
                },
                "hide.bs.dropdown": function (event) {
                    let hide = $(this).data('closable');
                    $(this).data('closable', true);
                    return hide;
                }
            });
        });

        // moved flickity to js so that draggable can be false on desktop and true on mobile
        // require jquery for flickity
        var jQueryBridget = require('jquery-bridget');
        var Flickity = require('flickity');

        // make Flickity a jQuery plugin
        Flickity.setJQuery($);
        jQueryBridget('flickity', Flickity, $);

        // recommendation flickity
        var recommendationItemsCount = 4;
        var recommendationTotalRelatedItems = $('.carousel--recommendations').data("recommendationitemscount");
        var moreRecommendationItemsThanVisible = recommendationTotalRelatedItems > recommendationItemsCount;
        var draggableRecommendation = moreRecommendationItemsThanVisible || document.documentElement.clientWidth <= 991;

        var $carouselRecommendation = $('.carousel--recommendations');

        $carouselRecommendation.flickity({
            cellAlign: "left",
            wrapAround: moreRecommendationItemsThanVisible,
            pageDots: false,
            draggable: draggableRecommendation,
            prevNextButtons: moreRecommendationItemsThanVisible
        });

        $('#header [data-toggle="dropdown"][data-trigger="hover"]').bootstrapDropdownHover({});

        function showSubdropdownFlyout(subdropdown) {
            $(subdropdown).siblings('.show').removeClass('show');
            $(subdropdown).addClass('show');

            // Because the flyout needs to be positioned absolutely, we need to manually adjust the height, width, and position to get the appearance desired.
            let flyout = $(subdropdown).children('.subdropdown-menu');
            let submenu = $(subdropdown).closest('.desktop-navigation-menu__submenu');
            let distanceToTop = $(subdropdown).offset().top - submenu.offset().top; 
            flyout
                .css('minHeight', `${submenu.outerHeight()}px`)
                .css('top', `-${distanceToTop}px`);
            $(subdropdown).closest('.desktop-navigation-menu')
                .css('minHeight', `${flyout.outerHeight()}px`)
                .css('width', `${submenu.outerWidth() + flyout.outerWidth()}px`);
        }

        $('#header .desktop-navigation .desktop-navigation-menu__flyout-nav').menuAim({
            activate: function (e) {
                showSubdropdownFlyout(e);
            },
            deactivate: function (e) {
                //$(e).removeClass('show');
            },
            rowSelector: '> li.subdropdown'
        });
        // TODO: Switch flyout on focus.
        $('#header .desktop-navigation .desktop-navigation__navitem .desktop-navigation-menu__flyout-nav > li.subdropdown > a.nav-link').on('focus', (e) => {
            let dropdown = $(e.target).closest('li.subdropdown');
            if (!dropdown.hasClass('show'))
                showSubdropdownFlyout(dropdown);
        }) 
        $('#header .desktop-navigation .desktop-navigation__navitem').on('shown.bs.dropdown', function () {
            let dropdownMenuWithFlyout = $($(this).children('.dropdown-menu.has-flyout'));
            if (dropdownMenuWithFlyout.length) {
                let distanceToLeft = $(this).offset().left - $('#header .desktop-navigation .desktop-navigation__navitem').first().offset().left;
                dropdownMenuWithFlyout.css('left', `-${distanceToLeft}px`);
                showSubdropdownFlyout($(this).find('.desktop-navigation-menu__flyout-nav .subdropdown.show'));
            }
        });

        $("#header .dropdown").on('show.bs.dropdown', function () {
            // Bootstrap dropdowns were occasionally getting stuck, so we're manually hiding them again just in case.
            $("#header .dropdown-toggle.show").dropdown('hide');
            $("#header .dropdown").not("show").find(".dropdown-menu.show").removeClass('show');
        });

        var typeaheadIsFocused = false;
        window.toggleExpandedTypeaheadSearch = function (isExpanded) {
            $('#header #upper-nav').toggleClass('typeahead-expanded', isExpanded);
            typeaheadIsFocused = isExpanded;
        };
        // --- If we upgrade to React version to 17+, this should be able to be moved to TypeaheadApp.jsx and #typeahead-outer-wrapper can be removed
        // Starting from React version 17, it treats the react "blur" event as focusout internally
        $('#header #upper-nav #typeahead-outer-wrapper').on('focusout', (e) => {
            if (!e.relatedTarget) return; // If a user clicks on an element that can't be focused, focusout happens but focusin does not. 
                                          // If a user clicks on the dropdown, but not on a link, this might happen.
                                          // So this line makes it so we ignore that scenario for this event. TypeaheadApp.jsx has another event handler for clicking off entirely.

            typeaheadIsFocused = false;
            // focusout always fires before focusin. So we need to wait a sliver of time to make sure we're not immediately refocusing another applicable element
            setTimeout(() => {
                if (!typeaheadIsFocused) {
                    window.toggleExpandedTypeaheadSearch(false);
                    window.typeaheadApp && window.typeaheadApp.handleClickOutside();
                }
            }, 30);
        });
        $('#header #upper-nav #typeahead-outer-wrapper').on('focusin', (e) => {
            typeaheadIsFocused = true;
            if ($(e.target).hasClass('header-search-input'))
                window.toggleExpandedTypeaheadSearch(true);
        });
        // ------------------------------------------------------------------------------------------------------------------------------------------
    },

    initHash: () => {
        if (location.hash) {               // do the test straight away
            window.scrollTo(0, 0);         // execute it straight away

            setTimeout(function () {
                window.scrollTo(0, 0);     // run it a bit later also for browser compatibility
            }, 1);

            $(window).on('load', function () {
                var $header = $('#header'),
                    skip = !!$('skip-hash-anchor').length,
                    $anchorEl = $(location.hash),
                    headerHeight = $header.length ? $header.height() : 0,
                    offset = $anchorEl.length ? $(location.hash).offset().top - headerHeight : 0;

                if (offset > 0 && !skip) {
                    $('html, body').animate({
                        scrollTop: offset
                    }, 700, 'swing', function () { });
                }
            });

            $(document).ready(() => {
                $(location.hash + '.accordion__item .collapse').collapse('show');
            });
        }
    }
};